export function formatAmount(value: string | null, currency: string | null): string {
  if (!value) return "—";
  const num = Number(value);
  if (Number.isNaN(num)) return value;
  try {
    return new Intl.NumberFormat("cs-CZ", {
      style: currency ? "currency" : "decimal",
      currency: currency ?? undefined,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);
  } catch {
    return `${num.toFixed(2)} ${currency ?? ""}`.trim();
  }
}

/**
 * `2026-04-30` → `30.04.2026` (český formát).
 * Vstup je ISO datum (YYYY-MM-DD) z DB; pro pohodlí přijme i ISO timestamp.
 * Pokud nelze rozparsovat, vrátíme původní hodnotu, ať uživatel vidí, co tam je.
 */
export function formatDate(value: string | null): string {
  if (!value) return "—";
  const datePart = value.slice(0, 10);
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(datePart);
  if (!m) return value;
  return `${m[3]}.${m[2]}.${m[1]}`;
}

/**
 * ISO timestamp → `30.04.2026 18:42` (lokální TZ uživatele).
 */
export function formatDateTime(value: string | null): string {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  return `${dd}.${mm}.${yyyy} ${hh}:${mi}`;
}
